import {Button, Dialog, DialogContent, DialogTitle, Grid, MenuItem, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import axios from "axios";
import * as React from "react";
import {v4 as uuidv4} from "uuid";
import {Config} from "../../config/config";
import {Helpers, getGlobalVar} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import * as JSZip from "jszip";

const operators = [
    ">", "<", "=", ">=", "<="
];


const orderByFields = [
    "headquarter_level", "building_weight", "avgStars", "avgPercent", "loseRate", "totalMatch"
]

export class GetStrongBase extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: false,
            users: [],
            filter: {
                operator: ">",
                hqLevel: 4,
                limit: 100,
                offset: 0,
                buildingWeight: 1000
            },
            amount: 0,
            popup: {
                show: false,
                user: null,
                parseBuildings: []
            },
            orderBy: {
                field: "headquarter_level",
                order: "asc"
            }
        }
    }

    componentDidMount(): void {
        this.fetchData();
    }

    async fetchData() {
        const url = `${Config.getInstance.apiUrl}/api/users/getStrongUsers`;
        const {filter} = this.state;

        const params = {
            operator: filter.operator,
            hqLevel: filter.hqLevel,
            limit: filter.limit,
            offset: filter.offset,
            buildingWeight: filter.buildingWeight
        }

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        this.setState({loading: true});

        const response = await axios.get(url, {params, headers});
        const data = response.data;

        const success = data.success;
        if (success) {
            const amount = data.amount;
            const users = data.users;

            this.setState({loading: false, amount, users});
        } else {
            PopupMessage.error("Failed to fetch data")
        }
    }

    async requestParseBuildings(userId: string) {
        const {users} = this.state;
        const user = users.find((u: any) => u.id === userId);

        const url = `${Config.getInstance.apiUrl}/api/users/parse_buildings`;
        const body = {
            buildings: user.buildings
        }

        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const result = await axios.post(url, body, {headers});

        const data = result.data;
        const success = data.success;
        if (success) {
            return data.parseBuildings;
        } else {
            PopupMessage.error("Failed to parse Buildings")
        }

        return [];
    }

    onShowBuildings = async (userId: string) => {
        const {users} = this.state;
        const user = users.find((u: any) => u.id === userId);

        if (user) {

            const url = `${Config.getInstance.apiUrl}/api/users/parse_buildings`;
            const body = {
                buildings: user.buildings
            }

            const headers = {
                Authorization: Helpers.getSessionId(),
            }

            const result = await axios.post(url, body, {headers});

            const data = result.data;
            const success = data.success;
            if (success) {
                const parseBuildings = data.parseBuildings;

                const {popup} = this.state;

                popup.show = true;
                popup.user = user;
                popup.parseBuildings = parseBuildings;
                this.setState({popup});
            } else {
                PopupMessage.error("Failed to parse Buildings")
            }
        }
        else {
            PopupMessage.error("User not found");
            return;
        }
    }

    onClosePopup = () => {
        const {popup} = this.state;
        popup.show = false;
        popup.user = null;
        this.setState({popup});
    }

    getBuildingName(building) {
        const item = getGlobalVar("BUILDINGS").find(el => el.id === building.id);
        return item ? item.name : "-";
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    async getUserData(user) {
        const missionData = {
            hqLevel: user.headquarter_level,
            troopMin: 0,
            troopMax: 0,
            troopTypeMin: 0,
            troopTypeMax: 0,
            buildings: [] as any,
        }

        const parseBuildings = await this.requestParseBuildings(user.id);

        for (const building of parseBuildings) {
            missionData.buildings.push({
                id: building.id,
                position: building.position,
                level: building.level,
                uniqueId: uuidv4()
            })
        }

        const data = JSON.stringify(missionData);

        return data;
    }

    async formatUserData(user) {
        const missionData = {
            hqLevel: user.headquarter_level,
            troopMin: 0,
            troopMax: 0,
            troopTypeMin: 0,
            troopTypeMax: 0,
            buildings: [] as any,
        }

        const parseBuildings = await this.requestParseBuildings(user.id);

        for (const building of parseBuildings) {
            missionData.buildings.push({
                id: building.id,
                position: building.position,
                level: building.level,
                uniqueId: uuidv4()
            })
        }

        const data = JSON.stringify(missionData);
        this.copyToClipboard(data);
        PopupMessage.success("Copied to clipboard");
    }

    displayBuildings(buildings) {
        return buildings.map((item: any, index: number) => {
            let element = <div>{item.level}</div>;
            return (
                <TableRow key={item.objectId}>
                    <TableCell>{item.id}</TableCell>
                    <TableCell>{item.index}</TableCell>
                    <TableCell>{Helpers.getLocalizationName(this.getBuildingName(item))}</TableCell>
                    <TableCell>
                        {element}
                    </TableCell>
                    <TableCell>{item.position}</TableCell>
                    <TableCell>{item.isRepaired ? "Yes" : "No"}</TableCell>
                    <TableCell>{item.isProcessing}</TableCell>
                </TableRow>
            )
        });
    }

    sortContent() {
        const {users, orderBy} = this.state;

        const field = orderBy.field;
        const order = orderBy.order;

        users.sort((a, b) => {
            if (order === "asc") {
                return a[field] - b[field];
            } else {
                return b[field] - a[field];
            }
        });

        this.setState({users});
    }

    onOrderByChange(key, event) {
        const value = event.target.value;
        const {orderBy} = this.state;

        orderBy[key] = value;

        this.sortContent();

        this.setState({orderBy});
    }

    async onExport() {
        const zip = new JSZip();

        const {users} = this.state;

        this.setState({loading: true});

        for (const user of users) {
            const {headquarter_level, building_weight, name} = user;
            const data = await this.getUserData(user);
            zip.file(`${headquarter_level}_${name}_${building_weight}.json`, data);
        }

        zip.generateAsync({type: "blob"})
            .then((content) => {
                const url: string = window.URL.createObjectURL(content);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `strong_base_data.zip`);
                document.body.appendChild(link);
                link.click();

                this.setState({loading: false});
            });
    }

    renderPopup() {
        const {popup} = this.state;

        return <Dialog
            open={popup.show}
            onClose={this.onClosePopup}
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>
                Strong User Details
            </DialogTitle>
            <DialogContent dividers>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell>Index</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Level</TableCell>
                            <TableCell>Position</TableCell>
                            <TableCell>Repaired</TableCell>
                            <TableCell>Processing</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.displayBuildings(popup.parseBuildings)}
                    </TableBody>
                </Table>
            </DialogContent>
        </Dialog>
    }

    renderOrderBy() {
        return <Paper style={{width: "100%"}}>
            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item container sm={12} spacing={2}>
                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            select
                            label="Order By"
                            value={this.state.orderBy.field}
                            onChange={(e) => this.onOrderByChange("field", e)}
                        >
                            {orderByFields.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            select
                            label="Order"
                            value={this.state.orderBy.order}
                            onChange={(e) => this.onOrderByChange("order", e)}
                        >
                            {["asc", "desc"].map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>

                    <Grid item sm={2}>
                        <Button
                            variant="contained"
                            onClick={() => this.onExport()}
                        >
                            Export
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Paper>
    }

    renderFilter() {
        const {filter} = this.state;

        return <Paper style={{width: "100%"}}>
            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item container sm={12} spacing={2}>
                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            select
                            label="Operator"
                            value={this.state.filter.operator}
                            onChange={(e) => {
                                this.setState({filter: {...this.state.filter, operator: e.target.value}})
                            }}
                        >
                            {operators.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            label="HQ Level"
                            type="number"
                            value={this.state.filter.hqLevel}
                            onChange={(e) => {
                                this.setState({filter: {...this.state.filter, hqLevel: e.target.value}})
                            }}
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            label="Building Weight"
                            type="number"
                            value={this.state.filter.buildingWeight}
                            onChange={(e) => {
                                this.setState({filter: {...this.state.filter, buildingWeight: e.target.value}})
                            }}
                        />
                    </Grid>

                </Grid>
                <Grid item container sm={12} justifyContent={"flex-end"} spacing={2}>

                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            label="Offset"
                            type="number"
                            value={this.state.filter.offset}
                            onChange={(e) => {
                                this.setState({filter: {...this.state.filter, offset: e.target.value}})
                            }}
                        />
                    </Grid>
                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            label="Limit"
                            type="number"
                            value={this.state.filter.limit}
                            onChange={(e) => {
                                this.setState({filter: {...this.state.filter, limit: e.target.value}})
                            }}
                        />
                    </Grid>

                    <Grid item sm={2}>
                        <Button
                            variant="contained"
                            onClick={async () => {
                                await this.fetchData();
                            }}
                        >
                            Fetch
                        </Button>
                    </Grid>

                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        const {users} = this.state;

        return <Paper style={{width: "100%"}}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>LoseRate</TableCell>
                        <TableCell>AVGSTar</TableCell>
                        <TableCell>AVGPercent</TableCell>
                        <TableCell>Matches</TableCell>
                        <TableCell>HQLevel</TableCell>
                        <TableCell>Weight</TableCell>
                        <TableCell>Buildings</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        users.map((user: any, index: number) => {
                            return <TableRow key={index}>
                                <TableCell>{index + 1}</TableCell>
                                <TableCell>{user.name}</TableCell>
                                <TableCell>{user.loseRate}</TableCell>
                                <TableCell>{user.avgStars}</TableCell>
                                <TableCell>{user.avgPercent}</TableCell>
                                <TableCell>{user.totalMatch}</TableCell>
                                <TableCell>{user.headquarter_level}</TableCell>
                                <TableCell>{user.building_weight}</TableCell>
                                <TableCell >
                                    <Button
                                        variant="contained"
                                        onClick={() => this.onShowBuildings(user.id)}
                                    >
                                        Show
                                    </Button>
                                </TableCell>
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        onClick={() => this.formatUserData(user)}
                                    >
                                        Copy Data
                                    </Button>
                                </TableCell>
                            </TableRow>
                        })
                    }
                </TableBody>
            </Table>
        </Paper>
    }

    render() {
        return <Paper className="contentPadding" style={{width: "100%"}}>
            <Typography variant="h4">Strong Base: {this.state.amount}</Typography>
            <br></br>
            {this.renderFilter()}
            {this.renderOrderBy()}
            <br></br>
            {this.renderContent()}
            {this.renderPopup()}
        </Paper>
    }
}